<template>
  <v-card flat class="no-fondo">
    <!-- Botonera -->
    <div class="buttons d-flex justify-start w-100 py-2 mt-2">
      <v-btn
        class="ma-2"
        @click="$emit('importar')"
        v-if="!vistaOperador && !id"
      >
        <span class="material-symbols-outlined">file_open</span>
        {{$t('general.importar')}}
      </v-btn>

      <v-btn
        class="ma-2"
        @click="$emit('exportar')"
        v-if="!vistaOperador"
      >
        <span class="material-symbols-outlined">file_save</span>
        {{$t('general.exportar')}}
      </v-btn>

      <v-btn
        class="ma-2"
        @click="$emit('descargar-in')"
        v-if="!id && mostrarBotonDescargarIn"
      >
        <span class="material-symbols-outlined">download</span>
        {{$t('general.descargar_input')}}
      </v-btn>
    </div>

    <!-- Mensaje informativo -->
    <div class="backup-center">
    <v-alert
        type="info"
        variant="tonal"
        class="backup-alert"
    >
    <template #prepend>
    <v-icon size="24" color="#1776BF">mdi-information</v-icon>
  </template>
      {{$t('mensajes.explicacion_botones')}}
    </v-alert>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'ComponenteBackup',
  props: {
    vistaOperador: { type: Boolean, required: true },
    id: { type: [String, Number, null], default: null },
    mostrarBotonDescargarIn: { type: Boolean, default: false },
  },
  emits: ['importar', 'exportar', 'descargar-in'],
};
</script>

<style scoped>
.no-fondo { background: transparent; }
.buttons :deep(.v-btn) {
  border-radius: 8px;
}
.backup-center {
  min-height: 50vh;          
  display: flex;
  justify-content: center;   
  align-items: center;      
}


.backup-alert {
  max-width: 900px;
  width: 90%;
  color: #000 !important;                
  background-color: #F2F2F2;
  border: 2px solid #1776BF;
}


</style>